var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 15V6.62617M3.52148 6.62617V2C3.52148 1.44771 3.96872 1 4.52101 1C5.5709 1 7.31536 1 9.10449 1C11.9526 0.999999 12.6045 1.79322 12.6045 3.625C12.6045 5.45678 12.1425 6.6875 9.10449 6.6875C6.06652 6.6875 3.52148 6.62617 3.52148 6.62617ZM3.52148 6.62617H0.0214844",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78688 9.75H0.0214844C-0.130414 9.75 0.584273 9.75 0.520982 9.75H5.78688ZM5.78688 9.75H7.116H7.49574",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.2edd147e7cfcb168f0130f9c418235b4.svg";
export { ForwardRef as ReactComponent };